import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EAlertBoxType, IAlertBoxConfig } from './alert-box.interface';

@Component({
  selector: 'app-alert-box',
  templateUrl: './alert-box.component.html',
  styleUrl: './alert-box.component.scss',
  standalone: true,
})
export class AlertBoxComponent implements OnInit {
  @Input() type: EAlertBoxType = EAlertBoxType.INFO;
  @Input() config!: Partial<IAlertBoxConfig>;
  @Output() closeBox: EventEmitter<boolean> = new EventEmitter<boolean>();

  public ngOnInit(): void {
    this.config = {
      dismissable: true,
      ...this.config,
    };
  }

  public close(): void {
    this.closeBox.emit(true);
  }
}
